import React, { useEffect, useState } from "react";
import { useLocation, Redirect } from "react-router-dom";
import { Tab, Tabs, TabList, TabPanel, TabPanels, Container } from "@deere/fuel-react";
import STAdminCases from "./STAdminCases";
import { getSubtierCleansingData, deleteSubtierRegistry, saveSubtierMasterData,saveSubtierRecords } from "../../services/survey.service";
import STAdminMaster from "./STAdminMaster";
import { useOktaAuth } from '@okta/okta-react'
import { getLikeNameRecords, getSubtierUniquesAndDuplicates, getCountryList } from '../../utils/utils.js'
import { ST_ADMIN_CASES } from '../../utils/surveyLiterals';
import { CircularIndicator } from '../../components/CircularIndicator'
import { SUBTIER_MENU_ACTIONS } from "../../utils/constants"
import { ERR_DESC_COUNTRIES_SERVICE_NOT_RECHEABLE, ERR_TITLE_COUNTRIES_SERVICE_NOT_RECHEABLE } from "../../utils/errorLiterals";
import PositionedSnackbarAlert from '../../components/PositionedSnackbarAlert.js'
import {GRAL_VALIDATION_MSGS,GRAL_ALERT_SEVERITIES} from "../../utils/constants";
import {useUserInfo} from '../../providers/userProvider.js';
import {getExtraGoldenRecordFields} from '../../utils/cleansingUtils.js';

export default function STAdmin() {
    const [likeNameRecordList, setLikeNameRecordList] = useState(undefined);
    const [loading, setLoading] = useState(true);
    const [subtierCleansingData, setSubtierCleansingData] = useState([]);
    const { authState } = useOktaAuth();
    const [uniquesAndDuplicatesList, setUniquesAndDuplicatesList] = useState(null);
    const location = useLocation();
    const [countryList, setCountryList] = useState({});
    const [openAlert, setOpenAlert] = useState(false);
    const [message, setMessage] = useState('');
    const [severity, setSeverity] = useState('success');
    const [refreshMasterData ,setRefreshMasterData] = useState(true);
    const userInfo = useUserInfo();
    const createdBy = userInfo? userInfo.userID : '';


    useEffect(() => {
        setLoading(true)
        const tmpCampaignId = location.state === undefined ? {} : location.state.campaignId;
        if (tmpCampaignId && !uniquesAndDuplicatesList) {
            getSubtierCleansingData(tmpCampaignId, authState.accessToken.accessToken).then((response) => {
                setSubtierCleansingData(response);
                const tmpUniquesAndDuplicatesList = getSubtierUniquesAndDuplicates(response.completedSubtierSuppliers);
                const tmpLikeNameRecordList = getLikeNameRecords(
                    response && response.incompletedSubtierSuppliers ? response.incompletedSubtierSuppliers : [],
                    tmpUniquesAndDuplicatesList && tmpUniquesAndDuplicatesList ? tmpUniquesAndDuplicatesList.duplicatedSTList : []
                )
                setUniquesAndDuplicatesList(tmpUniquesAndDuplicatesList);
                setLikeNameRecordList(tmpLikeNameRecordList);
                setLoading(false);
            }).catch(err => {
                console.log(err)
                setLoading(false)
            });
        }
    }, []);

    useEffect(() => {
        const getAllCountries = async () => {
            const result = await getCountryList(authState.accessToken.accessToken);
            setCountryList(result);
        }
        getAllCountries();

    }, [authState.accessToken.accessToken]);

    const removeSubmittedRow = (subtierIdList, isUnique) => {
        if (isUnique) {
            const newUniqueList = uniquesAndDuplicatesList.uniqueSTList.filter((uniqueST) => subtierIdList.indexOf(uniqueST.id) === -1);
            const newUniqueAndDuplicatesList = { duplicatedSTList: uniquesAndDuplicatesList.duplicatedSTList, uniqueSTList: newUniqueList };
            setUniquesAndDuplicatesList(newUniqueAndDuplicatesList);
        } else {
            const newSubtierIncompleteList = subtierCleansingData.incompletedSubtierSuppliers.filter((incompleteST) => subtierIdList.indexOf(incompleteST.id) === -1);
            const newSubtierCleasingData = { incompletedSubtierSuppliers: newSubtierIncompleteList, completedSubtierSuppliers: subtierCleansingData.completedSubtierSuppliers }
            setSubtierCleansingData(newSubtierCleasingData)
        }
        setSeverity(GRAL_ALERT_SEVERITIES.success)
        setOpenAlert(true);
        setMessage(GRAL_VALIDATION_MSGS.succesfully)
        setTimeout(() => {
            setOpenAlert(false);
        }, 4000)
    }

    const deleteSelectedRows = (subtierIdList, isUnique) => {
        deleteSubtierRegistry(subtierIdList, authState.accessToken.accessToken).then((response) => {
            removeSubmittedRow(subtierIdList, isUnique);
        }).catch(err => {
            console.log(err)
            setLoading(false)
            setSeverity(GRAL_ALERT_SEVERITIES.error)
            setOpenAlert(true);
            setMessage(GRAL_VALIDATION_MSGS.error_while_deleting)
            setTimeout(() => {
              setOpenAlert(false);
            }, 4000)      
        });
    };

    const createSelectedRows = (subtierIdList) => {
        let newGoldenRecords = [];
        let goldenRecordsExtraFields = []
        uniquesAndDuplicatesList.uniqueSTList.forEach((uniqueST) => {
            if (subtierIdList.indexOf(uniqueST.id) !== -1) {
                const tmpGoldenRecord={
                    "ids": [uniqueST.id],
                    "supplierName": uniqueST.subtierSupplierName,
                    "streetAddress": uniqueST.streetAddress,
                    "country": uniqueST.country,
                    "city": uniqueST.city,
                    "state": uniqueST.state,
                    "postalCode": uniqueST.postalCode
                };

                newGoldenRecords.push(tmpGoldenRecord);
                goldenRecordsExtraFields.push({...tmpGoldenRecord, ...getExtraGoldenRecordFields(uniqueST,createdBy)});
            }
        });
        handleSubmit(subtierIdList, newGoldenRecords,goldenRecordsExtraFields);
    };

    const handleSubmit = async (subtierIdList, goldenRecord, goldenRecordsExtraFields) => {
        try {
            if (goldenRecordsExtraFields){
                await saveSubtierRecords(authState.accessToken.accessToken,goldenRecordsExtraFields);
            }
            await saveSubtierMasterData(authState.accessToken.accessToken, goldenRecord);
            removeSubmittedRow(subtierIdList, true);
            setRefreshMasterData(true);
        } catch (e) {
            alert('An error occurs while saving, please try again.')
            setRefreshMasterData(false);
        }
    }

    if (!countryList) {
        return (
            <Redirect
                to={{
                    pathname: "/error",
                    state: { errorTitle: ERR_TITLE_COUNTRIES_SERVICE_NOT_RECHEABLE, errorDescription: ERR_DESC_COUNTRIES_SERVICE_NOT_RECHEABLE },
                }}
            />
        );
    }


    return (
        loading ?   <Container fluid={"true"}>
                        <CircularIndicator message={'Retrieving Subtier Data'} details={'This will take a few minutes'} />
                    </Container> 
                    :
                    <Container fluid={"true"}>
                        {openAlert && <PositionedSnackbarAlert message={message} open={openAlert} severity={severity.toLowerCase()} />}
                        <Tabs variant="container">
                            <TabList aria-label="example tabs" variant="fullWidth">
                                <Tab label="Incomplete Entries" />
                                <Tab label="Unique Records" />
                                <Tab label="Like Name" />
                                <Tab label="Golden Records" />
                            </TabList>
                            <TabPanels>
                                <TabPanel>
                                    <STAdminCases 
                                        stType={ST_ADMIN_CASES.INCOMPLETE} 
                                        rowsData={subtierCleansingData.incompletedSubtierSuppliers} 
                                        deleteFunction={deleteSelectedRows} 
                                        actionButton={SUBTIER_MENU_ACTIONS.DELETE}
                                        actionFunction={deleteSelectedRows} 
                                        removeFunction={removeSubmittedRow}
                                        countryList={countryList}
                                        isUnique = {false} 
                                        setRefreshMasterData={setRefreshMasterData}
                                        />
                                </TabPanel>
                                <TabPanel>
                                    <STAdminCases 
                                        stType={ST_ADMIN_CASES.UNIQUE} 
                                        rowsData={uniquesAndDuplicatesList.uniqueSTList}
                                        deleteFunction={deleteSelectedRows} 
                                        actionButton={SUBTIER_MENU_ACTIONS.UPDATE} 
                                        actionFunction={createSelectedRows} //TODO: Create function
                                        removeFunction={removeSubmittedRow}
                                        countryList={countryList}
                                        isUnique = {true} 
                                        setRefreshMasterData={setRefreshMasterData}
                                        /> 
                                </TabPanel>
                                <TabPanel>
                                    <STAdminCases stType={ST_ADMIN_CASES.LIKENAME} rowsData={likeNameRecordList}  actionFunction={deleteSelectedRows} setRefreshMasterData={setRefreshMasterData} />
                                </TabPanel>                       
                                <TabPanel>
                                    <STAdminMaster countryList={countryList} setRefreshMasterData={setRefreshMasterData} refreshMasterData={refreshMasterData}/>
                                </TabPanel>
                            </TabPanels>
                        </Tabs>
                    </Container>
    );
}